import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonSlides, ModalController } from '@ionic/angular';
import { ExistFile } from 'src/app/service/util/file.service';
import { ImageViewComponent } from '../../modal/image-view/image-view.component';

@Component({
  selector: 'img-slides',
  templateUrl: './img-slides.component.html',
  styleUrls: ['./img-slides.component.scss'],
})
export class ImgSlidesComponent implements OnInit {

  @Input() set List(v) {
    if(this.imgList != v) {
      this.imgList = [];
      setTimeout(() => {
        this.imgList = v;
      }, 100)
    }
  }

  @ViewChild('slides') slides:IonSlides;
  activeSlide:number = 0;

  slideOpts = {
    autoHeight: true,
    spaceBetween: 20,
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true
    }
  }

  imgList:ExistFile[] = [];
  constructor(
    private _modal: ModalController
  ) { }

  ngOnInit() {}

  async slideChange() {
    this.activeSlide = await this.slides.getActiveIndex();
  }
  prev() {
    this.slides.slidePrev();
  }
  next() {
    this.slides.slideNext();
  }

  async imgPreview(index) {
    const modal = await this._modal.create({
      component: ImageViewComponent,
      componentProps: {
        imgList: this.imgList,
        index
      }
    });
    modal.present();
  }
}
